import { Navigate, useLocation } from "react-router-dom";

/** Unknown nested addresses fall back through their parents, replacing each invalid address. */
export function ParentRouteRedirect({ overviewPath }: { overviewPath: string }) {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, "");
  const separator = path.lastIndexOf("/");
  const parent = separator > 0 ? path.slice(0, separator) : overviewPath;
  return <Navigate to={parent} replace />;
}
